module.exports = __webpack_public_path__ + "img/divnotex_logo_large_black.f0be8da6.png";